<template>
  <div id="faq" class="faq-container fr-container">
    <h2 class="title">You have questions? <span>We have answers</span></h2>
    <md-tabs @md-changed="onChange" v-model="tab">
      <md-tab id="tab-home" md-label="General"></md-tab>
      <md-tab id="tab-posts" md-label="Technical"></md-tab>
    </md-tabs>
    <md-list-item v-for="item in activeQuestions" :key="item.id" md-expand>
      <span class="md-list-item-text">{{ item.question }}</span>
      <md-list slot="md-expand">
        <md-list-item class="md-inset" v-html="item.answer"></md-list-item>
      </md-list>
    </md-list-item>
    <Button title="Learn more from support"></Button>
  </div>
</template>

<script>
import Button from "../../shared/Button";

export default {
  data() {
    return {
      tab: 'tab-home',
      data: {
        'tab-home': [
          {
            question: 'Where does my money go?',
            answer: 'As you might have guessed, we don’t put all the eggs in one basket, ' +
                'so all the investor’s money is split between our services: Smart Trading Bots: ' +
                'We have several trading bots built with love by our professional developers.' +
                ' All the bots are AI based and we have put different strategies in each one and ' +
                'have been testing them for quite some time to make sure it does everything we want' +
                ' it to do without any problem. As of right now we have 3 working bots and few others are in development ' +
                'and will be available in the future. Our smart trading bots, ' +
                'controlled by our professional traders, make you passive income while you sleep',
            id: 1
          },
          {
            question: 'What is Algorithmic Trading ?',
            answer: 'Algorithmic Trading is the process of using computers programmed to follow a ' +
                'defined set of instructions for placing a trade in order ' +
                'to generate profits at a speed and frequency that is impossible for a human trader',
            id: 2
          },
          {
            question: 'Adventages of Automated Trading Systems',
            answer: '1. Reduced the possibility of mistakes by human traders based on emotional and psychological factors.\n' +
                '<br/>2. Trades are executed instantly and at the best possible prices\n' +
                '<br/>3. Simultaneous automated checks on multiple market conditions\n' +
                '<br/>4. 24/7 analysing market conditions and looking best opportunities to enter a trade',
            id: 3
          },

        ],
        'tab-posts': [
          {
            question: 'How to sign up? ',
            answer: 'To use our services and have a taste of decentralization, it is necessary to sign-up on our website. ' +
                'To do that, you have to click "Earn" on home page, after that, simply click "Sign Up", put your email address along with password and confirm the email. ' +
                'After that you will have to do KYC, so prepare your documents! Anything you send us is confidential and we do not store your information on the website.',
            id: 4
          },
          {
            question: 'Is KYC required?',
            answer: 'Yes',
            id: 5
          },
          {
            question: 'Are there any deposit/withdrawal fees?',
            answer: 'yes (1-1%)',
            id: 6
          },
        ],
      }
    }
  },
  computed: {
    activeQuestions() {
      return this.data[this.tab]
    }
  },
  methods: {
    onChange(e) {
      this.tab = e
    }
  },
  components: {
    Button
  }
}
</script>

<style lang="scss" scoped>
.faq-container ::v-deep {
  background: black;
  padding-top: 96px;
  @media only screen and (max-width: 767px) {
    padding-top: 30px;
  }

  .title {
    display: block;
    margin: 0 auto;
    font-style: normal;
    font-weight: 500;
    font-size: 48px;
    color: $base-color;
    @media only screen and (max-width: 767px) {
      font-size: 32px;
    }

    span {
      color: white;
      display: block;
    }
  }

  .md-tabs-navigation {
    margin: 40px 0 0;
    background: rgba(19, 27, 58, 0.8) !important;
    border-radius: 110px;
    width: fit-content;
    @media only screen and (max-width: 767px) {
      width: 100%;
      margin: 20px 0 0;
    }
  }

  .md-tabs-indicator {
    display: none;
  }

  .md-button {
    border-radius: 40px;
    width: 155px;
    height: 40px;
    border: unset !important;
    max-width: unset;
    @media only screen and (max-width: 767px) {
      width: 33%;
    }

    .md-ripple {
      padding: 0 !important;
    }

    &.md-active {
      background: linear-gradient(253.87deg, #42E8E0 3.7%, #251B6F 81.82%);
    }

    .md-button-content {
      font-family: 'Rubik';
      font-weight: 500;
      font-size: 16px;
      color: #FFFFFF;
      text-transform: none;
      @media only screen and (max-width: 767px) {
        font-size: 14px;
      }
    }
  }

  .md-list-expand {
    .md-list {
      margin-top: 16px;
      @media only screen and (max-width: 767px) {
        margin-top: 0;
      }
    }
  }

  .md-list-item-expand {
    margin-top: 20px;
    padding: 16px 40px 16px 24px;
    border: 1px solid rgba(49, 197, 225, 0.5);
    border-radius: 15px;
    @media only screen and (max-width: 767px) {
      padding: 12px;
    }

    .md-icon-image {
      svg {
        fill: white !important;
      }
    }

    .md-list-item-text {
      font-family: 'Rubik';
      font-style: normal;
      font-weight: 500;
      font-size: 20px;
      color: #FFFFFF;
      @media only screen and (max-width: 767px) {
        font-size: 15px;
      }
    }

    .md-list-item-content {
      padding: 0;
    }

    .md-list-item-container {
      white-space: initial !important;
    }

    .md-list {
      padding: 0;
      background: black;
      font-family: 'Rubik';
      font-style: normal;
      font-weight: normal;
      font-size: 16px;
      line-height: 26px;
      margin-top: 0;
      background: transparent;
      color: #FFFFFF;
      @media only screen and (max-width: 767px) {
        font-size: 15px;
        line-height: 23px;
      }

      .md-list-item {
        white-space: normal;
      }
    }
  }
}
</style>